// extracted by mini-css-extract-plugin
export default {"activateToggle":"activate-toggle_activateToggle__-VUvb"};